/**
 * @deprecated These methods are deprecated and have no effect.
 * The host automatically manages iframe height.
 */
export function createResizeFunctions() {
  /** @deprecated No effect - host manages iframe height automatically. */
  const resize = (_height: number): void => {};

  /** @deprecated No effect - host manages iframe height automatically. */
  const autoResize = (): void => {};

  /** @deprecated No effect - host manages iframe height automatically. */
  const stopAutoResize = (): void => {};

  return { resize, autoResize, stopAutoResize };
}
